import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Mujeres que están siendo ignoradas o enviadas a la "zona de espera".', 'Si sientes que él perdió el interés y ya no te busca como antes.', 'Para quien se cansó de dar el 100% y recibir migajas de atención.', 'Mujeres que quieren recuperar su poder emocional y su dignidad.'];
  const notForWho = ['Personas en relaciones sanas y equilibradas que no necesitan cambios.', 'Quien busque manipular para causar daño emocional real.', 'Si no estás dispuesta a guardar silencio por al menos 48 horas.'];
  return <section className="py-24 relative" data-id="element-16">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-17">
        <div className="grid lg:grid-cols-2 gap-12" data-id="element-18">
          {/* Para quién es */}
          <FadeIn direction="right" data-id="element-19">
            <div className="bg-dark-100/50 p-8 md:p-10 border-t-2 border-gold-500 h-full" data-id="element-20">
              <h3 className="text-2xl md:text-3xl font-serif text-white mb-8" data-id="element-21">
                Para quién <span className="text-gold-400 italic" data-id="element-22">SÍ</span> es:
              </h3>
              <ul className="space-y-6" data-id="element-23">
                {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-24">
                    <div className="mt-1 bg-gold-500/20 p-1 rounded-full" data-id="element-25">
                      <Check className="w-4 h-4 text-gold-400" data-id="element-26" />
                    </div>
                    <span className="text-gray-300 text-lg" data-id="element-27">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién no es */}
          <FadeIn direction="left" delay={0.2} data-id="element-28">
            <div className="bg-dark-100/30 p-8 md:p-10 border-t-2 border-gray-700 h-full opacity-80" data-id="element-29">
              <h3 className="text-2xl md:text-3xl font-serif text-gray-400 mb-8" data-id="element-30">
                Para quién <span className="italic" data-id="element-31">NO</span> es:
              </h3>
              <ul className="space-y-6" data-id="element-32">
                {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-33">
                    <div className="mt-1 bg-gray-800 p-1 rounded-full" data-id="element-34">
                      <X className="w-4 h-4 text-gray-500" data-id="element-35" />
                    </div>
                    <span className="text-gray-400 text-lg" data-id="element-36">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}